import { render } from "./BasePagination.vue?vue&type=template&id=3bcab32f&scoped=true&ts=true"
import script from "./BasePagination.vue?vue&type=script&lang=ts"
export * from "./BasePagination.vue?vue&type=script&lang=ts"

import "./BasePagination.vue?vue&type=style&index=0&id=3bcab32f&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcab32f"]])

export default __exports__